//Форматирование даты
export function formatDate(isoString: string): string {
  const date = new Date(isoString);
  
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}

export function formatDateDay(isoString: string): string {
  const date = new Date(isoString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

export function formatedDateDay(isoString?: string): string {
  if (isoString) {
    const date = new Date(isoString);
    const today = new Date();
  
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
  
    const todayDay = today.getDate();
    const todayMonth = today.getMonth();
    const todayYear = today.getFullYear();
  
    // Проверяем, совпадает ли с сегодняшним днём
    if (day === todayDay && month === todayMonth && year === todayYear) {
      return "Сегодня";
    }
  
    // Названия месяцев в родительном падеже (для формата "29 июня")
    const monthNames = [
      "января", "февраля", "марта", "апреля", "мая", "июня",
      "июля", "августа", "сентября", "октября", "ноября", "декабря"
    ];
  
    return `${day} ${monthNames[month]}`;
  } else {
    return ''
  }
}

export function getTimeDifference(date1: string, date2: string): string {
  const diffMs = new Date(date2).getTime() - new Date(date1).getTime();
  const diffSeconds = Math.floor(diffMs / 1000);

  const days = Math.floor(diffSeconds / 86400); 
  const hours = Math.floor((diffSeconds % 86400) / 3600);
  const minutes = Math.floor((diffSeconds % 3600) / 60);
  const seconds = diffSeconds % 60;

  let result = [];
  if (days > 0) result.push(`${days} ${getDayWord(days)}`);
  if (hours > 0) result.push(`${hours} ${getHourWord(hours)}`);
  if (minutes > 0) result.push(`${minutes} ${getMinuteWord(minutes)}`);
  if (seconds > 0 && result.length === 0) result.push(`${seconds} ${getSecondWord(seconds)}`);

  return result.join(", ");
}

//Дни/часы/минуты/секунды
function getDayWord(days: number): string {
  if (days % 10 === 1 && days % 100 !== 11) return "день";
  if ([2, 3, 4].includes(days % 10) && ![12, 13, 14].includes(days % 100)) return "дня";
  return "дней";
}

function getHourWord(hours: number): string {
  if (hours % 10 === 1 && hours % 100 !== 11) return "час";
  if ([2, 3, 4].includes(hours % 10) && ![12, 13, 14].includes(hours % 100)) return "часа";
  return "часов";
}

function getMinuteWord(minutes: number): string {
  if (minutes % 10 === 1 && minutes % 100 !== 11) return "минута";
  if ([2, 3, 4].includes(minutes % 10) && ![12, 13, 14].includes(minutes % 100)) return "минуты";
  return "минут";
}

function getSecondWord(seconds: number): string {
  if (seconds % 10 === 1 && seconds % 100 !== 11) return "секунда";
  if ([2, 3, 4].includes(seconds % 10) && ![12, 13, 14].includes(seconds % 100)) return "секунды";
  return "секунд";
}

export function pluralize(count: number, one: any, few: any, many: any) {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  
  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) return many;
  if (lastDigit === 1) return one;
  if (lastDigit >= 2 && lastDigit <= 4) return few;
  return many;
}